export default {"src":"/uk/_next/static/media/myPensionsIconGrey.d6e76d12.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};